<template>
    <div class="version-list">
        <div v-for="(version, index) in item.combos" :key="version.name">
            <binary
                :item="version"
                :type="type"
                :auto-open="index === 0"
                :is-new="index === 0"
                @recordUserDownload="recordUserDownload"
                @containerDeployValidate="containerDeployValidate">
            </binary>
        </div>
    </div>
</template>

<script>
import binary from './binary.vue';
export default {
    name: 'versionList',
    components: {
        binary
    },
    props: {
        type: String,
        item: Object
    },
    data () {
        return {
            info: {},
            tabList: [
                { name: '二进制版本', key: 'binary' },
                { name: '容器化版本', key: 'containerize' }
            ]
        }
    },
    methods: {
        recordUserDownload (cur) {
            this.$emit('recordUserDownload', cur)
        },
        containerDeployValidate (cur) {
            this.$emit('containerDeployValidate', cur)
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// versionList.vue?05f20feb